const DEPOSIT_NAME = 'povratna naknada'
const DEPOSIT_TAX_CATEGORY = 'HR:POVNAK'
const RATE_DECIMALS = 1e10

const round2 = n => Math.round((n + Number.EPSILON) * 100) / 100

export function isDepositLine (line) {
  if (typeof line.taxRate !== 'number' || line.taxRate !== 0) return false
  if (line.taxCategoryName === DEPOSIT_TAX_CATEGORY) return true
  const name = String(line.name || '').trim().replace(/\s+/g, ' ').toLowerCase()
  return name === DEPOSIT_NAME
}

const isDepositCharge = charge => charge.charge && charge.taxCategoryName === DEPOSIT_TAX_CATEGORY

export function documentDepositTotal (charges) {
  return (charges || []).filter(isDepositCharge).reduce((sum, charge) => sum + (charge.amount || 0), 0)
}

export function otherDocumentCharges (charges) {
  return (charges || []).filter(charge => !isDepositCharge(charge))
}

export function splitLines (lines) {
  const articleLines = []
  const depositLines = []
  lines.forEach(line => (isDepositLine(line) ? depositLines : articleLines).push(line))
  return { articleLines, depositLines }
}

export function discountPercent ({ quantity, unitPrice, discount }) {
  if (discount < 0) throw new RangeError('discount must not be negative')
  const base = quantity * unitPrice
  if (!base) return 0
  return Math.round(discount / base * 100 * RATE_DECIMALS) / RATE_DECIMALS
}

export function toPurchaseLine (line) {
  const kolicina = line.quantity
  let cijena = line.unitPrice
  let priceAdjusted = false
  const stopaPdv = Number.isFinite(line.taxRate) ? line.taxRate : 0
  const netTotal = line.lineTotal - (line.depositFee || 0)
  const ukupnaCijenaBezPdv = round2(netTotal)

  let rabat = discountPercent({ ...line, discount: Math.max(0, line.discount || 0) })
  if (round2(kolicina * cijena * (1 - rabat / 100)) !== ukupnaCijenaBezPdv && kolicina * cijena) {
    // Allowances apply first, a charge after them: keep the invoice rabat and solve the price instead
    if (line.chargesTotal > 0 && rabat < 100) {
      cijena = netTotal / (kolicina * (1 - rabat / 100))
      priceAdjusted = true
    } else {
      rabat = Math.round((1 - netTotal / (kolicina * cijena)) * 100 * RATE_DECIMALS) / RATE_DECIMALS
    }
  }

  return {
    kolicina,
    jedinicnaCijenaBezPdv: cijena,
    jedinicnaCijenaSPdv: (!priceAdjusted && line.priceWithTax) || round2(cijena * (1 + stopaPdv / 100)),
    stopaPdv,
    rabat,
    jedinicnaCijenaSRabatom: kolicina ? ukupnaCijenaBezPdv / kolicina : 0,
    ukupnaCijenaBezPdv,
    mjernaJedinica: line.unitCode
  }
}
